<template>
  <div class="wf-onboarding">
    <div class="onboarding-screen">
      <div class="illustration">
        <WfErrorIcon />
      </div>
      <div class="content">
        <div class="text">
          <h3>Safari support coming soon</h3>
          <p>
            We are currently working on supporting Safari. For now use <strong>Chrome</strong> or
            the <strong>Figma Desktop App</strong>.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import WfErrorIcon from '@/components/icons/WfErrorIcon.vue';
</script>
